var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { apiCreateProffitSearchTrialInvite } from '../../../../actions/ProffitSearchTrialAction';
import { PROFFIT_SEARCH_PLANS } from '../../../../define/consts/proffit_search/proffit_search_service';
import { wrapDispatch, wrapNotifyError } from '../../../../helpers/action';
import { getUserMode } from '../../../../helpers/auth';
import { getProffitSearchValues, isProffitSearchTrialPlan, isProffitSearchFreePlan, isProffitSearchStandardPlan, } from '../../../../helpers/profile';
import { useSlideSearchLockItem } from '../../../../helpers/use/proffit_search/common/useSlideSearchLockItem';
import { useBoolState, useUnmountRef } from '../../../../helpers/use/useHook';
import { getErrorFromErrorObject } from '../../../../helpers/validate';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import SlideAddButton from '../../Common/Action/Button/SlideAddButton';
import SlideSearchRegistrationModals from '../../Common/Modal/SlideSearchRegistrationModals';
import AccountPlanBodyFree from './Parts/AccountPlan/AccountPlanBodyFree';
import AccountPlanBodyTrial from './Parts/AccountPlan/AccountPlanBodyTrial';
import AccountPlanTitle from './Parts/AccountPlan/AccountPlanTitle';
const AccountPlan = () => {
    const profile = useSelector((state) => state.profile);
    const auth = useSelector((state) => state.auth);
    const userMode = getUserMode(auth);
    const proffitSearch = useMemo(() => getProffitSearchValues(profile), [profile]);
    const { canRegistrationTrial, plan, trialCountDown } = proffitSearch;
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            text: 'アカウント管理',
        },
    ], []);
    const isTrial = isProffitSearchTrialPlan(plan);
    const isFree = isProffitSearchFreePlan(plan);
    const isStandard = isProffitSearchStandardPlan(plan);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { email, hideCompleteModal, hideFormModal, hidePaidModal, initialValues, isShowCompleteModal, isShowFormModal, isShowPaidModal, kanaRef, onClickLockItem, onSubmitRegistration, } = useSlideSearchLockItem.useSlideSearchLockItemModal(profile, userMode, dispatch, unmountRef);
    const planName = useMemo(() => {
        const { title } = PROFFIT_SEARCH_PLANS.find((v) => v.value === plan) || {};
        return title;
    }, [plan]);
    const { boolState: isTrialShowForm, changeFalse: hideTrialForm, changeTrue: showTrialForm, } = useBoolState(true);
    const trialFormInitialValues = useMemo(() => ({
        email: ['', ''],
    }), []);
    /**
     * トライアル招待のsubmit
     * @type {(function(*=): Promise<void>)|*}
     */
    const onSubmitTrialInvite = useCallback((formValues, formDispatch, formProps) => __awaiter(void 0, void 0, void 0, function* () {
        const { reset } = formProps;
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield wrapDispatch(formDispatch, apiCreateProffitSearchTrialInvite(formValues));
                if (!unmountRef.current) {
                    hideTrialForm();
                    formDispatch(reset());
                }
            }
            catch (e) {
                if (unmountRef.current) {
                    return;
                }
                const { data = {} } = getErrorFromErrorObject(e);
                const { messages = {} } = data;
                const keys = Object.keys(messages);
                // エラーメッセージが存在しない場合は通常のエラーとして処理
                if (!keys.length) {
                    throw e;
                }
                // indexに合わせて、SubmissionError用のオブジェクトを作成
                const errors = keys
                    .map((key) => {
                    const index = parseInt(key.match(/[^.]+$/)[0], 10);
                    const error = messages[key] || [];
                    return { error: error[0] || '', index };
                })
                    .filter((v) => typeof v.index === 'number' && v.error);
                const errorMessages = {
                    email: formValues.email.map((unused, index) => {
                        const { error = '' } = errors.find((v) => v.index === index) || {};
                        return error;
                    }),
                };
                throw new SubmissionError(errorMessages);
            }
        }));
    }), [hideTrialForm, unmountRef]);
    // スタンダードプランの場合はリダイレクト
    if (isStandard) {
        return _jsx(CustomRedirect, { to: '/proffit_search' });
    }
    return (_jsxs(Layout, Object.assign({ headerType: 'proffit_search', mainClassName: 'l-main slide_search_page slide_search_mypage_account_plan_page', sticky: _jsx(SlideAddButton, { disabled: isFree, onClickLockItem: onClickLockItem }), stickyClassName: 'slide_search_page add_button_footer' }, { children: [_jsxs("div", Object.assign({ className: 'l-container' }, { children: [_jsx(Breadcrumb, { lists: pans }), _jsxs("div", Object.assign({ className: 'mypage_container' }, { children: [_jsx(AccountPlanTitle, { isTrial: isTrial, planName: planName, trialCountDown: trialCountDown }), _jsxs("div", Object.assign({ className: 'mypage_content' }, { children: [isTrial && (_jsx(AccountPlanBodyTrial, { initialValues: trialFormInitialValues, isShowForm: isTrialShowForm, onSubmit: onSubmitTrialInvite, profile: profile, showForm: showTrialForm, unmountRef: unmountRef })), isFree && _jsx(AccountPlanBodyFree, {})] }))] }))] })), _jsx(SlideSearchRegistrationModals, { canRegistrationTrial: canRegistrationTrial, email: email, hideCompleteModal: hideCompleteModal, hideFormModal: hideFormModal, hidePaidModal: hidePaidModal, initialValues: initialValues, isShowCompleteModal: isShowCompleteModal, isShowFormModal: isShowFormModal, isShowPaidModal: isShowPaidModal, kanaRef: kanaRef, onSubmitRegistration: onSubmitRegistration, userMode: userMode })] })));
};
export default AccountPlan;
